module.exports = __webpack_public_path__ + "img/careclinics.e302b5ae.jpg";